import { render, staticRenderFns } from "./EditOnboard.vue?vue&type=template&id=296760c8&scoped=true"
import script from "./EditOnboard.vue?vue&type=script&lang=js"
export * from "./EditOnboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296760c8",
  null
  
)

export default component.exports